import { FC, ReactNode } from 'react'
import cn from 'classnames'

import { ReactComponent as Spinner } from '@src/assets/spinner.svg'
import style from '@src/components/Button/Button.module.scss'

type ButtonProps = {
  htmlType?: 'submit' | 'reset' | 'button'
  className?: string
  outline?: boolean
  type?: 'primary' | 'secondary' | 'text' | 'textSecondary'
  disabled?: boolean
  icon?: ReactNode
  onClickFunc?: any
  loading?: boolean
}

export const Button: FC<ButtonProps> = ({
  onClickFunc,
  children,
  htmlType,
  className,
  disabled,
  outline,
  type = 'primary',
  icon,
  loading,
}) => (
  <button
    // eslint-disable-next-line react/button-has-type
    type={htmlType ?? 'button'}
    className={cn(style.btn, style[type], outline && style.outline, className)}
    disabled={disabled || loading}
    onClick={onClickFunc}
  >
    {icon}
    <div>{children}</div>
    {loading && <Spinner className={style.spinner} />}
  </button>
)
